<template>
  <div id="app">
    <keep-alive>
      <router-view name="navigation" />
    </keep-alive>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style  lang="scss">
#app {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 100vh;

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: $greyArea;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: $greyArea;
  }
}
</style>
